import { tv } from "tailwind-variants";

import { monsterrat } from "@/services/styles/fonts";

export const getPackageCardClass = tv({
  base: [
    "max-w-[420px]",
    "relative flex max-w-md flex-col rounded-2xl bg-white",
    "shadow-[0_0_32px_4px_rgba(0,90,217,0.1)]",
  ],
});

export const getCoverImageClass = tv({
  base: ["w-full rounded-t-2xl object-cover"],
  variants: {
    coverSize: {
      xs: ["h-[150px]"],
      sm: ["h-54"],
      base: ["h-64"],
    },
  },
  defaultVariants: {
    coverSize: "base",
  },
});

export const getCoverImageWrapperClass = tv({ base: ["relative cursor-default select-none"] });

export const getPriceClass = tv({
  base: [
    monsterrat.className,
    "absolute top-0 right-0 z-10 rounded-tr-2xl rounded-bl-xl bg-white px-2 py-4 font-semibold text-primary-500",
  ],
});

export const getNameClass = tv({ base: [monsterrat.className, "px-3 pb-4 font-semibold text-base 2xl:text-lg"] });
